/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "companies",
            "endpoint": "https://skiv1ic912.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "stripe",
            "endpoint": "https://58yimxigg5.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "users",
            "endpoint": "https://5b2be4xm2l.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "websites",
            "endpoint": "https://e9hup5an1l.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:9c27d35f-e535-48e8-af20-d0a8479f312b",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_EZXpl8bvU",
    "aws_user_pools_web_client_id": "29rourtoloukdv9cs90e8k0997",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "NAME",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "azatysbucket142413-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "companies-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "steerings-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "users-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "websites-prod",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
